module.exports = __webpack_public_path__ + "img/icon-delete.8f08cb75.svg";